import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';

export const CashCollectionsLayout = () => {
    return (
        <MainLayout>
            <Outlet />
        </MainLayout>
    );
};
